import React from 'react';
import Navigation from './Navigation';
import NavigationMobile from '../../Components/NavigationMobile/NavigationMobile';
import useIsMobile from '../../Hooks/useIsMobile';

const NavigationContainer = ({ blockElements }) => {
  const isMobile = useIsMobile();

  return isMobile ? (
    <NavigationMobile />
  ) : (
    <Navigation blockElements={blockElements} />
  );
};

export default NavigationContainer;
